













































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import PageNames from '@/router/PageNames';
import Validator from '@/lib/validator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { CompanyListModule } from '@/store/modules/companyList';
import CreateCompanyRequest from '@/models/Companies/CreateCompanyRequest';

@Component({
    name: 'CompanyCreate'
})
export default class extends GiganautVueDialog {
 
    public entity = new CreateCompanyRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.entity = new CreateCompanyRequest();
        }
    }

	get loadingDialog() {
		return CompanyListModule.loadingDialog;
	}

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
		this.entity.registeredName = this.entity.brandName;
        await CompanyListModule.createCompany(this.entity);
		this.dialog = false;
		if (CompanyListModule.newCompany !== null) {
			this.$router.push({ name: PageNames.AgencyCompanyDetails, params: { companyid: CompanyListModule.newCompany.id } });
		}
    }
}
